export default {
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["درباره ما"])},
  "Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قیمت:"])},
  "شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شنبه"])},
  "یکشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["یکشنبه"])},
  "دوشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["دوشنبه"])},
  "سه شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سه شنبه"])},
  "چهارشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["چهارشنبه"])},
  "پنج شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["پنج شنبه"])},
  "جمعه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["جمعه"])},
  "باز": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["باز"])},
  "بسته": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بسته"])}
}